import React from 'react';
import DocumentPage from '../../components/DocumentPage';

const PurchaseOrders = () => {
  const columns = [
    { key: 'total', label: 'Total', type: 'currency' },
    { key: 'expected_delivery', label: 'Expected Delivery', type: 'date' },
  ];

  const formFields = [
    { name: 'supplier_id', label: 'Supplier', type: 'party', required: true },
    { name: 'subtotal', label: 'Subtotal', type: 'number', defaultValue: 0 },
    { name: 'tax', label: 'Tax', type: 'number', defaultValue: 0 },
    { name: 'total', label: 'Total', type: 'number', defaultValue: 0 },
    { name: 'expected_delivery', label: 'Expected Delivery', type: 'date' },
    {
      name: 'status',
      label: 'Status',
      type: 'select',
      defaultValue: 'draft',
      options: [
        { value: 'draft', label: 'Draft' },
        { value: 'sent', label: 'Sent' },
        { value: 'confirmed', label: 'Confirmed' },
        { value: 'received', label: 'Received' },
        { value: 'cancelled', label: 'Cancelled' },
      ],
    },
  ];

  return (
    <DocumentPage
      title="Purchase Orders"
      description="Manage supplier purchase orders with print and email"
      apiEndpoint="purchase-orders"
      partyType="supplier"
      partyApi="suppliers"
      columns={columns}
      formFields={formFields}
      docType="purchase_order"
        lineItemsEnabled
    />
  );
};

export default PurchaseOrders;
